import React from 'react';
import { appConfig } from '../../configureApp';

const Asterisk = () => {
  const clientColor = appConfig.reactAppEnv === 'scti' ? '#D92E43' : '#ed1c24';
  return <i style={{ color: clientColor, fontSize: '7px' }} className="fa fa-asterisk fa-xs" aria-hidden="true" />;
};

export default Asterisk;



// WEBPACK FOOTER //
// ./app/components/Asterisk/index.js